import React, { useState } from 'react';

interface ProviderCardProps {
  id: string;
  name: string;
  logo?: string;
  onClick: (id: string) => void;
  accentColor?: string;
}

const ProviderCard: React.FC<ProviderCardProps> = ({ id, name, logo, onClick, accentColor = '#2563eb' }) => {
  const [pressed, setPressed] = useState(false);

  return (
    <button
      type="button"
      onPointerDown={() => setPressed(true)}
      onPointerUp={() => { setPressed(false); onClick(id); }}
      onPointerLeave={() => setPressed(false)}
      className="flex flex-col items-center justify-center p-5 rounded-2xl border-2 transition-all duration-200"
      style={{
        background: pressed ? `${accentColor}0d` : '#fff',
        borderColor: pressed ? accentColor : '#e2e8f0',
        transform: pressed ? 'scale(0.96)' : 'scale(1)',
        boxShadow: pressed ? `0 0 0 3px ${accentColor}33` : '0 1px 4px rgba(0,0,0,0.06)',
      }}
    >
      <div className="w-16 h-16 flex items-center justify-center rounded-full mb-3 overflow-hidden"
        style={{ background: '#f1f5f9' }}>
        {logo ? (
          <img
            src={`https://kaoxet.net/storage/${logo}`}
            alt={name}
            className="w-14 h-14 object-contain"
          />
        ) : (
          <span className="text-2xl font-black text-white" style={{ background: accentColor, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {name.charAt(0)}
          </span>
        )}
      </div>
      <span className="text-sm font-bold text-slate-700 text-center leading-tight">{name}</span>
    </button>
  );
};

export default ProviderCard;
